import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import ReviewList from "./tabItems/ReviewList";
import AddReview from "./tabItems/AddReview";
import { setReview } from "../../store/slices/reviewSlice";

export const reviewTabConfig = {
    LIST: "1",
    ADD: "2"
}

const ReviewTab = () => {
    const [currentTab, setCurrentTab] = useState(reviewTabConfig.LIST);
    const [tabTada, setTabData] = useState({});
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setReview({}));
    }, [])

    const onSwitchTab = (key, data) => {
        setCurrentTab(key);
    }

    const tabs = [
        {
            key: reviewTabConfig.LIST,
            label: 'Reviews',
            children: <ReviewList onSwitchTab={onSwitchTab} />,
        },
        {
            key: reviewTabConfig.ADD,
            label: 'Add / Modify Review',
            children: <AddReview onSwitchTab={onSwitchTab} tabProps={{}} />,
        }
    ];

    const onChange = (key) => {
        setCurrentTab(key);
        if (key !== reviewTabConfig.ADD) {
            dispatch(setReview({}));
        }
    };

    return (
        <div>
            
            <div className="text-2xl pb-3">Reviews</div>
            <div className="px-4 border pb-6 bg-white pop-left">
                <Tabs defaultActiveKey="1" activeKey={currentTab} items={tabs} onChange={onChange} />
            </div>
        </div>
    )
}

export default ReviewTab;